import { AppLocale } from './types';

export const PRODUCT_GLOSSARY: Record<string, Record<AppLocale, string>> = {
  workspace: {
    en: 'Workspace',
    ru: 'Рабочее пространство',
    'zh-Hans': '工作空间',
  },
  credits: { en: 'Soaps', ru: 'Мыло', 'zh-Hans': '肥皂币' },
  generation: { en: 'Generation', ru: 'Генерация', 'zh-Hans': '生成' },
  asset: { en: 'Asset', ru: 'Материал', 'zh-Hans': '素材' },
  campaign: { en: 'Campaign', ru: 'Кампания', 'zh-Hans': '投放' },
  sandbox: { en: 'Sandbox', ru: 'Песочница', 'zh-Hans': '沙盒' },
  prompt: { en: 'Prompt', ru: 'Промпт', 'zh-Hans': '提示词' },
};
